import { Component, OnInit } from "@angular/core";
import { AuthService } from "../services/auth.service";
import { PedidoService } from "../services/pedido.service";
import { KanbanService } from "../services/kanban.service";
import { NotificacaoService } from "../services/notificacao.service";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
})
export class HomeComponent implements OnInit {
  informacoes: string;

  constructor(
    public pedidoService: PedidoService,
    public authService: AuthService,
    public kanbamService: KanbanService,
    private notificacaoService: NotificacaoService
  ) { }

  ngOnInit(): void {
    this.informacoes = `
      <style>
      </style>
    `;
  }
}
